import { removeAndAddListeners } from "../general/BuddyFuncs";

export default class FormSubmit {
  constructor(
    params = {
      form: "",
      submitFunc: () => {},
      justValidate: false,
    }
  ) {
    this.formSelector = params.form;
    this.form = null;
    this.inputs = [];
    this.selects = [];
    this.radiobtnHolders = [];

    this.submitFunc = params.submitFunc;

    this.justValidate = params.justValidate ? params.justValidate : false;

    this.lock = false;
  }

  init() {
    //set inits
    this.form = document.querySelector(this.formSelector);

    if (this.form) {
      removeAndAddListeners(this.form, "submit", (e) => this.handleSubmit(e));

      //set inputs
      this.inputs = this.form.querySelectorAll(
        `[data-required="true"], [required]`
      );
      this.selects = this.form.querySelectorAll("select");
      this.radiobtnHolders = this.form.querySelectorAll(".radiobtnsHolder");

      //listen for input
      this.inputs.forEach((input) => {
        input.setAttribute("novalidate", "");

        if (input.getAttribute("type") !== "checkbox") {
          removeAndAddListeners(input, "input", (e) =>
            this.handleChangeInput(e)
          );

          removeAndAddListeners(input, "blur", (e) => this.handleBlurInput(e));
        } else {
          removeAndAddListeners(input, "change", (e) =>
            this.handleBlurInput(e)
          );
        }
      });

      //listen to selects
      this.selects.forEach((select) => {
        removeAndAddListeners(select, "change", (e) =>
          this.handleChangeSelect(e)
        );

        removeAndAddListeners(select, "blur", (e) =>
          this.handleChangeSelect(e)
        );
      });

      //listen to radio btns
      this.radiobtnHolders.forEach((holder) => {
        const radioBtns = holder.querySelectorAll("input[type=radio]");

        radioBtns.forEach((input) => {
          removeAndAddListeners(input, "change", (e) => {
            this.handleChangeRadio(e);
          });
        });
      });
    }
  }

  handleChangeRadio(e) {
    this.setRadioError(e.currentTarget.parentElement.parentElement);
  }

  handleChangeSelect(e) {
    this.checkValidity(e.currentTarget, true);
  }

  checkSelect(select) {
    return select.value !== "";
  }

  checkAllSelects() {
    let isOke = true;

    this.selects.forEach((select) => {
      if (!this.checkSelect(select)) {
        isOke = false;
      }
    });

    return isOke;
  }

  checkAllinputs() {
    let isOke = true;

    this.inputs.forEach((input) => {
      if (!this.checkValidity(input, true)) {
        isOke = false;
      }
    });

    return isOke;
  }

  checkRadioBtns() {
    let isOke = true;

    this.radiobtnHolders.forEach((radiobtnHolder) => {
      const radioBtns = radiobtnHolder.querySelectorAll("input[type=radio]");
      let isFilled = false;

      radioBtns.forEach((radioBtn) => {
        if (radioBtn.checked) {
          isFilled = true;
        }
      });

      //set error message
      this.setRadioError(radiobtnHolder, !isFilled);

      isOke = isFilled;
    });

    return isOke;
  }

  setRadioError(holder, isError = false) {
    const error = holder.parentElement.querySelector(".lbl-error");

    if (isError) {
      //error
      this.setMsg(error, error.dataset.errormsg);
    } else {
      //removeError
      this.setMsg(error);
    }
  }

  checkAllFields() {
    return (
      this.checkAllinputs() && this.checkAllSelects() && this.checkRadioBtns()
    );
  }

  handleSubmit(e) {
    e.preventDefault();

    if (!this.lock && this.checkAllFields()) {
      this.lock = true;
      const url = this.form.getAttribute("action");

      if (!this.justValidate) {
        fetch(url, {
          method: "POST",
          dataType: "json",
          contentType: false,
          enctype: "multipart/form-data",
          processData: false,
          body: new FormData(this.form),
        })
          .then((r) => r.json())
          .then((r) => this.handleResult(r));
      } else {
        //release lock
        this.lock = false;

        //only handle result
        this.submitFunc(new FormData(this.form));
      }
    } else {
      //display errors
      this.displayAllErrors();
    }
  }

  displayAllErrors() {
    this.inputs.forEach((input) => {
      this.checkValidity(input, true);
    });

    this.selects.forEach((select) => {
      this.checkValidity(select, true);
    });
  }

  handleResult(r) {
    this.lock = false;

    if (r.success) {
      //redirect to page
      this.submitFunc(r);
      //window.location.href = r.redirect;
    } else {
      //diplay main error message
    }
  }

  handleChangeInput(e) {
    this.checkValidity(e.currentTarget);
  }

  handleBlurInput(e) {
    this.checkValidity(e.currentTarget, true);
  }

  checkValidity(elem, setError = false) {
    let error = elem.parentElement.querySelector(".lbl-error");

    if (!error) {
      error = elem.parentElement.parentElement.querySelector(".lbl-error");
    }

    let isValid = false;

    if (elem.type === "checkbox") {
      isValid = elem.checked;
    } else if (elem.nodeName === "SELECT") {
      isValid = this.checkSelect(elem);
    } else {
      isValid = elem.checkValidity();
    }

    if (elem.type !== "checkbox") {
      if (isValid) {
        //is valid
        this.setMsg(error);
      } else {
        //is invalid
        if (setError) {
          this.setMsg(error, error.dataset.errormsg);
        }
      }
    } else {
      // just toggle error class on the labelText
      error = elem.parentElement.querySelector(".labelText");

      isValid ? error.classList.remove("error") : error.classList.add("error");
    }

    return isValid;
  }

  setMsg(elem, msg = "") {
    elem.textContent = msg;
  }
}
